import { combineReducers } from "redux";
import video, { VideoStore } from "../common/video/VideoReducer";
import search, { SearchStore } from "../viewer/search/SearchReducer";
import presenters, { PresentersStore } from "../presenters/PresentersReducer";
import user, { UserStore } from "../user/UserReducer";
import recommendList, { RecommendListStore } from "../common/homePage/HomePageReducer";
import header, { HeaderStore } from "./components/layout/header/HeaderReducer";
import videoFilter, { VideoFilterStore } from "../common/video/VideoFilterReducer";
import program, { ProgramStore } from "../stores/program/ProgramReducer";
import userFilter, { UserFilterStore } from "../presenters/UserFilterReducer";
import exProject, { ExProjectStore } from "../store/reducers/ExProjectReducer";
import exVideo, { ExVideoStore } from "../store/reducers/ExVideoReducer";
import slide, { SlideStore } from "../store/reducers/SlideReducer";
import statistics, { StatisticsStore } from "../store/reducers/StatisticsReducer";
import timeline, { TimelineStore } from "../studio/store/reducers/TimelineReducer";
import { directory, DirectoryStore } from "../studio/store/reducers/DirectoryReducer";
import { template, TemplateStore } from "../studio/store/reducers/TemplateReducer";
import { videoInfo, VideoInfoStore } from "../studio/store/reducers/VideoInfoReducer";
import { DocumentStore, document } from "../store/reducers/DocumentReducer";

export interface AppState {
    video: VideoStore;
    search: SearchStore;
    presenters: PresentersStore;
    user: UserStore;
    header: HeaderStore;
    recommendList: RecommendListStore;
    videoFilter: VideoFilterStore;
    userFilter: UserFilterStore;
    program: ProgramStore;
    exProject: ExProjectStore;
    exVideo: ExVideoStore;
    slide: SlideStore;
    statistics: StatisticsStore;
    timeline: TimelineStore;
    directory: DirectoryStore;
    template: TemplateStore;
    videoInfo: VideoInfoStore;
    document: DocumentStore;
}

const rootReducer = combineReducers({
    video,
    search,
    presenters,
    user,
    header,
    recommendList,
    videoFilter,
    userFilter,
    program,
    exProject,
    exVideo,
    slide,
    statistics,
    timeline,
    directory,
    template,
    videoInfo,
    document,
});

export default rootReducer;
